<template>
  <div>
    <div class="block">
      <van-form class="creatruleForm" ref="ruleForm" @submit="getOnruleFormSubmit">
        <div class="grey"></div>

        <van-cell center title="基础信息" class="title"> </van-cell>
        <van-field
          class="cellRow"
          label="商品名称"
          v-model="ruleForm.name"
          maxlength="25"
          name="name"
          required
          placeholder="请填写商品名称"
          :rules="[{ validator: validatorname, message: messageName }]"
        />
        <!-- 图片上传 -->
        <div class="uploadImage">
          <van-field
            v-model="ruleForm.goodPhotoList"
            required
            name="imageUrl"
            label="商品图"
            :rules="[{ required: true, message: '请上传商品图' }]"
          >
            <template #input>
              <upload-image
                :imageUrl="imageArr"
                :maxCount="maxCount"
                :width="auto"
                @success="uploadImageSuccess"
                @delete="deleteImage"
              ></upload-image>
            </template>
          </van-field>
          <p class="proposalImage">可上传多张，建议750*750像素或同等</p>
        </div>
        <!-- select -->
        <!-- 商品分类 -->
        <classification
          :label="label"
          :portraitText="portraitText"
          @portraits="portrait"
          v-model="ruleForm.gradeId"
          :gradeNames="ruleForm.gradeNames"
          @getNames="getNames"
        ></classification>
        <van-field
          class="cellRow portrait"
          label="商品亮点"
          v-model="ruleForm.subject"
          name="subject"
          placeholder="请输入商品亮点"
        />

        <van-cell center title="非卖品">
          <van-switch
            v-model="ruleForm.saleType"
            slot="right-icon"
            size="24"
            name="saleType"
            active-value="1"
            inactive-value="2"
            @change="changeSwitch"
          />
        </van-cell>
        <!-- select -->
        <van-field
          class="cellRow"
          v-model="ruleForm.showPicker"
          label="商品规格"
          readonly
          clickable
          name="resolution"
          :value="resolution"
          right-icon="arrow"
          @focus="onGetItem('1')"
          @click-right-icon="onGetItem('1')"
        />
        <van-popup v-model="showPicker" position="bottom">
          <van-picker
            show-toolbar
            :columns="typeArray"
            @confirm="onConfirms"
            @cancel="showPicker = false"
            value-key="name"
            ref="picker"
          />
        </van-popup>
        <div class="leftText">
          <van-field
            :disabled="isEdit && ruleForm.skuKeyValueList.length > 0 && ruleForm.resolution == 1"
            required
            class="cellRow portrait"
            label="商品价格"
            v-model="ruleForm.sellPrice"
            name="sellPrice"
            placeholder="请输入商品价格"
            :rules="[{ required: true }]"
            type="number"
          />
          <p>元</p>
        </div>
        <div class="leftText">
          <van-field
            :disabled="isEdit && ruleForm.skuKeyValueList.length > 0 && ruleForm.resolution == 1"
            class="cellRow portrait"
            label="划线价"
            v-model="ruleForm.originPrice"
            name="originPrice"
            placeholder="划线价"
            type="number"
          />
          <p>元</p>
        </div>
        <div class="leftText">
          <van-field
            type="number"
            required
            :disabled="isEdit && ruleForm.skuKeyValueList.length > 0 && ruleForm.resolution == 1"
            class="cellRow portrait"
            label="库存"
            v-model="ruleForm.balanceCount"
            name="balanceCount"
            placeholder="库存"
            :rules="[{ required: true }]"
          />
          <p>件</p>
        </div>
        <div class="grey"></div>

        <van-cell center title="物流设置" class="title"> </van-cell>
        <van-cell center title="支持自提" class="iconCell">
          <van-icon
            name="info-o"
            @click="portrait('设置后需填写自提地址，买家购买时可选择“自提”')"
          />
          <van-switch
            v-model="ruleForm.onSite"
            slot="right-icon"
            size="24"
            name="onSite"
            :active-value="true"
            :inactive-value="false"
          />
        </van-cell>
        <van-field
          v-show="ruleForm.onSite"
          class="cellRow portrait"
          label="自提地址"
          v-model="ruleForm.siteAddress"
          name="siteAddress"
          placeholder="请输入自提地址"
          :rules="[{ required: ruleForm.onlySite || ruleForm.onSite }]"
        />
        <van-cell center title="仅自提" class="iconCell" v-show="ruleForm.onSite">
          <van-icon name="info-o" @click="portrait('设置后买家购买时无快递运费，只能选择“自提”')" />
          <van-switch
            v-model="ruleForm.onlySite"
            slot="right-icon"
            size="24"
            name="onlySite"
            :active-value="true"
            :inactive-value="false"
          />
        </van-cell>
        <div
          v-show="
            (!ruleForm.onlySite && !ruleForm.onSite) || !ruleForm.onlySite || !ruleForm.onSite
          "
        >
          <van-cell center title="运费到付" class="iconCell">
            <van-icon
              name="info-o"
              @click="
                portrait('设置后不需填写“快递运费”，卖家发到付快递，买家收到货后，支付快递费')
              "
            />
            <van-switch
              v-model="ruleForm.freightBuyerPay"
              slot="right-icon"
              size="24"
              name="freightBuyerPay"
              :active-value="true"
              :inactive-value="false"
            />
          </van-cell>
          <van-field
            v-show="!ruleForm.freightBuyerPay"
            required
            class="cellRow portrait"
            label="快递运费"
            v-model="ruleForm.freight"
            name="freight"
            :rules="[
              {
                required: ruleForm.freightBuyerPay
                  ? false
                  : true && ruleForm.onlySite
                  ? false
                  : true,
              },
            ]"
            placeholder="请输入快递运费"
            type="number"
          />
        </div>

        <div class="grey"></div>
        <van-cell center title="商品详情" class="title"> </van-cell>
        <van-field
          class="cellRow textareaDetail"
          v-model="ruleForm.goodsDetail"
          type="textarea"
          name="goodsDetail"
          label="请输描述商品"
        />
        <!-- 图片上传 -->
        <div class="goodsupload">
          <van-field v-model="ruleForm.detail" name="imageUrl" class="goodsImage">
            <template #input>
              <upload-image
                :imageUrl="imgageDetail"
                :maxCount="maxCount"
                width="100%"
                height="auto"
                @success="uploadImageSuccessGoods"
                @delete="deleteImageGoods"
              ></upload-image>
            </template>
          </van-field>
          <p class="proposalImage">添加商品详情图</p>
        </div>
        <div class="submit">
          <van-button
            block
            type="info"
            native-type="button"
            class="whiteBtn"
            @click="getFormNotSubmit"
            >暂不售卖</van-button
          >
          <van-button block type="info" native-type="button" @click="getFormSubmit"
            >上架售卖</van-button
          >
        </div>
      </van-form>
    </div>
    <van-popup v-model="isLoading" class="isLoading"> 加载中... </van-popup>
  </div>
</template>
<script>
import uploadImage from '../components/uploadImage';
import { goodsCreate, goodsView, goodsUpdate } from '@/api/goods';
import { formatDateTime, validateKeywords } from '@/utils/index';
import classification from '../components/classification';

import { Dialog, Toast } from 'vant';
export default {
  components: { uploadImage, classification },
  data() {
    return {
      label: '商品分类',
      portraitText: '请选择对应的商品分类，不同的商品分类会展示在“在艺直播”的不同位置',
      maxCount: '20',
      auto: 'auto',
      isLoading: false,
      ruleForm: {
        saleType: '2',
        isPublicAuction: true,
        goodsDetail: null,
        category: '',
        categoryId: '',
        balanceCount: '100', // 库存
        code: '', // 商品编码
        detail: '', // 商品详情
        endTime: 1894204800000, // 售卖结束时间
        flagDelete: null, // 数据状态
        onSite: false, // 是否自提
        onlySite: false,
        freightBuyerPay: false, // 运费到付
        siteAddress: '', // 自提地址
        freight: '', // 快递费
        goodGroupToList: [], // 商品分组
        goodPhotoList: [], // 商品图
        goodStockList: [], // 规格明细
        goodTypeId: '1', // 商品类型
        imageHeight: null,
        imageUrl: '', // 商品图封面
        imageWidth: null,
        name: '', // 商品名
        originPrice: null, // 原价
        sellPrice: '1', // 现价
        skuKeyValueList: [],
        startTime: null, // 售卖开始时间
        subject: '', // 商品亮点
        titleTag: '',
        gradeId: [],
        gradeId1: null,
        gradeId2: null,
        gradeId3: null,
        resolution: 0,
        showPicker: '单一规格',
      },
      resolution: 0,
      showPicker: false,
      showTypePicker: false,
      resource: { goodPhotoList: [], detail: [] },
      typeArray: [
        { code: 0, name: '单一规格' },
        { code: 1, name: '多规格' },
      ],
      // 直播类型
      liveType: [
        { code: 0, name: '拍品导购直播' },
        { code: 1, name: '普通导购直播' },
      ],
      minHour: 10,
      maxHour: 20,
      minDate: new Date().getTime(),
      maxDate: new Date(2019, 10, 1).getTime(),
      currentDate: new Date().getTime(),
      showPickerDatetime: false,
      pid: null,
      imageArr: [],
      imgageDetail: [],
    };
  },
  created() {
    this.init();
  },
  methods: {
    validatorname(value) {
      return value ? !validateKeywords(value) : false;
    },
    messageName(value) {
      if (!value) {
        return '';
      } else {
        return !validateKeywords(value) ? true : validateKeywords(value);
      }
    },
    formatDateTime,
    init() {
      this.pid = this.$route.params.id;
      this.isEdit = !!this.pid;
      if (this.isEdit) {
        this.editRender();
      }
    },
    // 编辑信息
    editRender() {
      goodsView({ id: this.pid })
        .then(res => {
          console.log('res.data', res);
          Object.assign(this.ruleForm, res.data);
          Object.assign(this.resource.goodPhotoList, res.data.goodPhotoList);
          this.ruleForm.goodPhotoList.map(v => {
            this.imageArr.push(v.imageUrl);
          });
          this.ruleForm.gradeId = [
            +res.data.gradeId1 || null,
            +res.data.gradeId2 || null,
            +res.data.gradeId3 || null,
          ];
          if (!this.ruleForm.gradeNames) {
            this.ruleForm.gradeNames = '1';
          }
          console.log(this.ruleForm.gradeNames);
          if (res.data.skuKeyValueList.length != 0) {
            this.ruleForm.showPicker = '多规格';
            this.ruleForm.resolution = 1;
          } else {
            this.ruleForm.showPicker = '单一规格';
            this.ruleForm.resolution = 0;
          }
          if (this.ruleForm.saleType) {
            this.ruleForm.saleType = this.ruleForm.saleType.toString();
          }
          //取出详情里的src
          if (res.data.detail.indexOf('src')) {
            const url = res.data.detail.split(/\<img\s*src=\"([^\"]*?)\"[^>]*>/gi);
            for (let i = 0; i < url.length; i++) {
              if (url[i].indexOf('http') != -1) {
                this.imgageDetail.push(url[i]);
                this.resource.detail.push({ imageUrl: url[i] });
              }
            }
          }
          // 取出富文本里的文字
          if (res.data.detail.indexOf('<p>') != -1) {
            let p = res.data.detail.split('</p>')[0];
            let isImg = res.data.detail.split('</p>')[0];
            if (isImg.indexOf('<img') != -1) {
              isImg = isImg.split('<img');
              isImg = isImg[0].split('<p>')[1];
            }
            if (p.indexOf('<p>') != -1 && p.indexOf('<img') != -1) {
              let isp = p.split('<img')[0];
              isp = isp.split('<p>')[1];
              this.ruleForm.goodsDetail = isp;
            } else if (p.indexOf('<p>') != -1) {
              p = p.split('<p>')[1];
              this.ruleForm.goodsDetail = p;
            } else {
              this.ruleForm.goodsDetail = isImg;
            }
            console.log('this.ruleForm.goodsDetail', this.ruleForm.goodsDetail);
          }
        })
        .catch(err => {
          this.isLoading = false;
        });
    },
    getFormSubmit(value) {
      this.ruleForm.flagDelete = 0;
      this.$refs.ruleForm.submit();
    },
    getFormNotSubmit(value) {
      this.ruleForm.flagDelete = 3;
      this.$refs.ruleForm.submit();
    },
    // 提交
    getOnruleFormSubmit(value) {
      console.log(value);
      const param = value;
      const imageUrl = this.resource.goodPhotoList[0];
      console.log(imageUrl);
      const oneImage = {
        imageUrl: imageUrl.imageUrl,
        imageHeight: imageUrl.imageHeight,
        imageWidth: imageUrl.imageWidth,
      };
      Object.assign(param, this.ruleForm, this.resource, oneImage);
      param.startTime = this.currentDate; //销售开始时间
      param.goodStockList.startTime = this.currentDate;
      param.goodStockList.validStartTime = this.currentDate;
      //商品文字描述和图片描述
      param.detail = '';
      let arrDetail = '';
      if (this.resource.detail) {
        this.resource.detail.map(v => {
          arrDetail += `<img src="${v.imageUrl}"/>`;
        });
      }
      param.detail = `<p>${param.goodsDetail}${arrDetail}</p>`;
      param.gradeId.map((v, index) => {
        let gradeIdIndex = 'gradeId' + (index + 1);
        param[gradeIdIndex] = v;
      });
      if (param.resolution == 0) {
        param.goodStockKeyValue = [];
        param.goodStockList = [];
        param.skuKeyValueList = [];
      }
      console.log(this.resource);
      console.log(param);

      // 区分编辑/新增
      if (this.isEdit) {
        this.onEdit(param);
      } else {
        this.onAdd(param);
      }
    },
    // 新增
    onAdd(param) {
      this.isLoading = true;
      goodsCreate(param)
        .then(res => {
          this.isLoading = false;
          Toast(res.message);
          this.$router.replace('/goods/list');
        })
        .catch(err => {
          this.isLoading = false;
        });
    },
    onEdit(param) {
      this.isLoading = true;
      goodsUpdate(param)
        .then(res => {
          this.isLoading = false;
          this.$router.replace('/goods/list');
          Toast(res.message);
        })
        .catch(err => {
          this.isLoading = false;
        });
    },
    uploadImageSuccessGoods(imageResult) {
      this.resource.detail.push({
        imageUrl: imageResult.imageUrl,
        imageWidth: imageResult.imageWidth,
        imageHeight: imageResult.imageHeight,
      });
    },
    deleteImageGoods(value) {
      this.resource.detail.splice(value.index, 1);
    },
    uploadImageSuccess(imageResult) {
      this.resource.goodPhotoList.push({
        imageUrl: imageResult.imageUrl,
        imageWidth: imageResult.imageWidth,
        imageHeight: imageResult.imageHeight,
      });
    },
    deleteImage(value) {
      this.resource.goodPhotoList.splice(value.index, 1);
    },
    onConfirm(value, index) {
      this.ruleForm.type = value.code;
      this.ruleForm.showTypePicker = value.name;
      this.showTypePicker = false;
    },
    onConfirms(value, index) {
      if (value.code == 1) {
        Toast('多规格设置，请在电脑端进行处理');
        return;
      }
      this.ruleForm.resolution = value.code;
      this.ruleForm.showPicker = value.name;
      this.showPicker = false;
    },
    onGetItem(type) {
      if (type == 0) {
        this.showTypePicker = true;
      } else if (type == 1) {
        this.showPicker = true;
      } else {
        this.showPickerDatetime = true;
      }
    },
    getNames(value) {
      this.ruleForm.gradeNames = value;
    },
    onInput(value) {
      let date = new Date(value);
      this.ruleForm.timingRelease = formatDateTime(date);
      // this.ruleForm.timingReleaseDate = date.getTime();
      this.ruleForm.liveTime = date.getTime();
      this.ruleForm.isTiming = 1;
      this.showPickerDatetime = false;
    },
    portrait(message) {
      Dialog({ message });
    },
    // 非卖品切换
    changeSwitch(value) {
      if (value == 1) {
        this.ruleForm.sellPrice = 0;
        this.ruleForm.balanceCount = 1;
      } else if (value == 2) {
        this.ruleForm.sellPrice = 1;
        this.ruleForm.balanceCount = 100;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.block .grey {
  width: 100%;
  height: 10px;
  background: #f8f8f8;
}
.block .title {
  font-size: 16px;
}
.creatruleForm {
  padding-bottom: 80px;
}
.van-form .submit {
  position: fixed;
  width: 90%;
  left: 50%;
  bottom: 10px;
  border: none;
  max-width: 750px;
  transform: translateX(-50%);
  text-align: center;
}
.van-form .submit .van-button--info {
  background: #222;
  color: #fff;
  border: none;
}
.van-form .proposalImage {
  background: #fff;
  font-size: 12px;
}
.van-form {
  padding-bottom: 60px;
}
/deep/ .van-form .goodsImage {
  overflow: auto;
}
/deep/ .van-form .goodsImage .van-uploader__upload-icon {
  display: none;
}
/deep/ .van-form .goodsImage .van-uploader__upload {
  height: 188px;
  width: 100%;
  background-image: url('../../assets/img/goodsImage.png');
  background-repeat: no-repeat;
  background-size: 30%;
  background-position: center;
}
/deep/ .van-form .goodsImage .van-uploader__preview {
  max-width: 100%;
  margin: 10px;
}
/deep/ .van-form .goodsImage .van-uploader .van-uploader__wrapper {
  flex-wrap: wrap;
}
.van-form .submit .van-button--info {
  display: inline-block;
  width: 45%;
}
.van-form .submit {
  display: flex;
  justify-content: space-around;
}
.van-form .submit .whiteBtn {
  background: #fff;
  border: 1px solid #000;
  color: #222;
}
.van-form .leftText {
  position: relative;
}
.leftText p {
  position: absolute;
  right: 20px;
  top: 12px;
  color: #333;
  font-size: 14px;
}
/deep/ .van-form .leftText .van-field__body {
  padding-right: 20px;
}
/deep/ .isLoading {
  font-size: 14px;
  background: transparent;
  color: #fff;
}
.uploadImage .van-cell::after {
  border: none;
}
.van-form .proposalImage {
  background: #fff;
  font-size: 12px;
  color: #999;
  padding: 10px 16px;
  border-bottom: 1px solid #ebedf0;
}
/deep/ .iconLeft .van-field__body .van-field__right-icon {
  position: absolute;
  left: -2em;
}
/deep/ .iconRight .van-field__left-icon {
  position: absolute;
  left: 5.5em;
}
/deep/ .iconCell .van-cell__left-icon {
  position: absolute;
  left: 5.5em;
}
.goodsupload {
  position: relative;
}
.goodsupload .proposalImage {
  position: absolute;
  bottom: 2em;
  background: transparent;
  width: 100%;
  text-align: center;
  border: none;
}
/deep/ .iconCell .van-cell__value {
  display: block;
  font-size: 16px;
  line-height: inherit;
  position: absolute;
  left: 5.5em;
}
/deep/ .van-form .van-cell,
/deep/ .van-form .van-cell .van-field__label,
/deep/ .iconCell .van-cell__value,
/deep/ .iconLeft .van-field__body .van-field__right-icon {
  color: #323233;
}
/deep/ .textareaDetail .van-field__control {
  height: 68px;
}
</style>
